var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23036",
    "data-name": "Raggruppa 23036",
    transform: "translate(-1826 -261)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_11790",
    "data-name": "Rettangolo 11790",
    width: 25,
    height: 25,
    rx: 4,
    transform: "translate(1826 261)",
    fill: "#3260cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-mail-open",
    "data-name": "Icon ionic-md-mail-open",
    d: "M19.17,9.7A1.571,1.571,0,0,0,18.4,8.33L10.71,4.5,3.016,8.33A1.662,1.662,0,0,0,2.25,9.7v7.692A1.616,1.616,0,0,0,3.861,19h13.7a1.616,1.616,0,0,0,1.611-1.611Zm-8.46,3.865L4.238,9.334,10.71,6.111l6.472,3.223Z",
    transform: "translate(1827.75 260.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationClose);
export default __webpack_public_path__ + "static/media/notification-close.fd71426ad4d881d3f81a39e4587aff31.svg";
export { ForwardRef as ReactComponent };